import React from "react";

import { ReportPageFooter } from "./ReportPageFooter";

export const ReportPageTemplate = ({
  club,
  date,
  firstData,
  indicatorBlocks,
  page,
  pageName,
  pageRef,
  secondData,
  totalPages,
  userName,
}) => {
  const hasSecond = !!secondData && Object.keys(secondData).length > 0;
  const infoTitle =
    pageName !== "Consistency Report"
      ? "Z Score"
      : "How do we measure Consistency";
  const infoBody =
    pageName !== "Consistency Report"
      ? "Z Score refers to how many standard deviations your data point is from the mean"
      : "This is measured based on how much variance you have across all your swings. The ideal value here is 0";

  const fmtSecondValue =
    typeof secondData?.value === "number"
      ? secondData?.value.toFixed(2)
      : secondData?.value ?? "";

  return (
    <div
      className="font-manrope mx-auto my-5 flex h-[1150px] w-[800px] flex-col bg-white p-20"
      ref={pageRef}
    >
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="text-base text-black">{pageName}</h2>
        <img alt="logo" className="h-6 w-auto" src="/images/logos/Logo.svg" />
      </div>

      {/* Top stat row */}
      <div className="flex justify-between gap-2 py-5">
        {/* Left stats */}
        <div className="grid w-2/5 grid-cols-2 gap-2">
          <div>
            <div className="text-xs font-bold text-black">
              {firstData.value}
            </div>
            <div className="text-grayTrue500 text-[9px]">{firstData.name}</div>
          </div>

          {hasSecond && (
            <div>
              <div className="text-xs font-bold text-black">
                {fmtSecondValue}
              </div>
              <div className="text-grayTrue500 text-[9px]">
                {secondData?.name}
              </div>
            </div>
          )}
        </div>

        {/* Right info box */}
        <div className="border-gray200 bg-gray50 w-3/5 rounded-md border p-2">
          <div className="text-gray900 text-[9px] font-bold">{infoTitle}</div>
          <div className="text-gray600 text-[9px]">{infoBody}</div>
        </div>
      </div>

      {/* Indicator groups/cards injected by parent */}
      {indicatorBlocks}

      {/* Footer */}
      <ReportPageFooter
        club={club}
        date={date}
        page={page}
        totalPages={totalPages}
        userName={userName}
      />
    </div>
  );
};
